import React, { useState } from "react";

const PALETTE = [
  ["#1E3A8A", "#3B82F6"], ["#B8860B", "#F59E0B"], ["#7C2D12", "#EA580C"],
  ["#065F46", "#10B981"], ["#831843", "#EC4899"], ["#3730A3", "#6366F1"],
  ["#92400E", "#D97706"], ["#155E75", "#06B6D4"], ["#5B21B6", "#8B5CF6"],
  ["#9F1239", "#F43F5E"], ["#1E40AF", "#60A5FA"], ["#854D0E", "#EAB308"],
];

function hashIdx(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h % PALETTE.length;
}

function initials(name) {
  const clean = name.replace(/[^A-Za-z0-9 ]/g, "").trim().split(/\s+/);
  if (clean.length === 1) return clean[0].slice(0, 2).toUpperCase();
  return (clean[0][0] + clean[1][0]).toUpperCase();
}

export function RestaurantLogo({ name = "", logo = null, size = 40, className = "" }) {
  const [broken, setBroken] = useState(false);
  const [a, b] = PALETTE[hashIdx(name)];
  const px = { width: size, height: size, minWidth: size };

  if (logo && !broken) {
    return (
      <img src={logo} alt={name} onError={() => setBroken(true)} style={px}
        className={`rounded-xl object-cover bg-white ${className}`} data-testid="restaurant-logo" />
    );
  }
  return (
    <div style={{ ...px, background: `linear-gradient(135deg, ${a}, ${b})` }}
      className={`rounded-xl flex items-center justify-center shrink-0 shadow ${className}`}
      data-testid="restaurant-logo">
      <span className="font-display font-extrabold text-white" style={{ fontSize: size * 0.4 }}>
        {initials(name)}
      </span>
    </div>
  );
}
